{
  "de": {
    "fleetDashboard": {
      "unnamed": "Ohne Titel",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "Neuigkeiten",
        "you": "Du",
        "kinds": {
          "member_joined": "Der Flotte beigetreten",
          "event_published": "Event veröffentlicht",
          "event_cancelled": "Event abgesagt",
          "contract_published": "Auftrag ausgeschrieben",
          "contract_claimed": "Auftrag übernommen",
          "contract_fulfilled": "Auftrag erfüllt",
          "inventory_transfer_completed": "Transfer abgeschlossen",
          "inventory_item_deposited": "Eingelagert",
          "inventory_item_withdrawn": "Entnommen"
        },
        "empty": {
          "title": "Noch nichts passiert",
          "hint": "Veröffentlichte Events und Aufträge landen hier, die neuesten zuerst."
        }
      },
      "events": {
        "title": "Anstehende Events",
        "signUp": "Anmelden",
        "empty": {
          "title": "Für die nächsten zwei Wochen ist nichts geplant",
          "hint": "Auf der Event-Seite siehst du, was später ansteht.",
          "hintCreate": "Trag eine Operation ein, und Mitglieder können sich sofort anmelden.",
          "action": "Event planen"
        }
      },
      "actionQueue": {
        "title": "Wartet auf dich",
        "joinRequests": {
          "one": "%{count} Beitrittsanfrage",
          "other": "%{count} Beitrittsanfragen"
        },
        "pendingTransfers": {
          "one": "%{count} eingehender Transfer offen",
          "other": "%{count} eingehende Transfers offen"
        },
        "partFailed": "Ein Teil dessen, was auf dich wartet, konnte gerade nicht geladen werden.",
        "empty": {
          "title": "Alles erledigt",
          "hint": "Beitrittsanfragen und eingehende Transfers, die eine Antwort brauchen, erscheinen hier."
        },
        "memberHealth": {
          "one": "%{count} Prüfung im Mitgliederbestand braucht Aufmerksamkeit",
          "other": "%{count} Prüfungen im Mitgliederbestand brauchen Aufmerksamkeit"
        }
      },
      "contracts": {
        "title": "Aufträge",
        "mine": "Deine Aufträge",
        "open": "Offen zur Übernahme",
        "partFailed": "Ein Teil der Aufträge konnte gerade nicht geladen werden.",
        "empty": {
          "title": "Keine offenen Aufträge",
          "hint": "Frühere Aufträge findest du auf dem Auftragsbrett.",
          "hintCreate": "Schreib einen Auftrag aus, den Mitglieder übernehmen können.",
          "action": "Auftrag ausschreiben"
        }
      },
      "inventory": {
        "title": "Inventar",
        "empty": "In letzter Zeit keine Inventarbewegungen.",
        "emptyMine": "Von deinen Sachen wurde zuletzt nichts bewegt.",
        "emptyHint": "Einlagerungen, Entnahmen und Transfers erscheinen hier.",
        "mine": "Meine",
        "fleet": "Flotte"
      },
      "newMembers": {
        "title": "Neue Mitglieder",
        "empty": {
          "title": "In letzter Zeit niemand Neues",
          "hint": "Mitglieder erscheinen hier, sobald sie beigetreten sind."
        }
      },
      "about": {
        "title": "Über die Flotte",
        "empty": {
          "title": "Noch keine Beschreibung",
          "hint": "Die Flotte hat sich noch nicht vorgestellt.",
          "hintEdit": "Erzähl neuen Mitgliedern, worum es in der Flotte geht.",
          "action": "Beschreibung schreiben"
        }
      },
      "week": {
        "emptyDay": "Am %{day} steht nichts an."
      },
      "online": {
        "title": "Gerade online (%{count})",
        "titlePending": "Gerade online",
        "friend": "Freund",
        "more": {
          "one": "und %{count} weiterer",
          "other": "und %{count} weitere"
        },
        "empty": {
          "title": "Sonst ist niemand online",
          "hint": "Mitglieder erscheinen hier, sobald sie sich anmelden."
        }
      },
      "announcements": {
        "post": "Ankündigung veröffentlichen",
        "postAction": "Veröffentlichen",
        "edit": "Ankündigung bearbeiten",
        "body": "Ankündigung",
        "until": "bis %{date}",
        "confirmRemove": "Diese Ankündigung für alle entfernen?",
        "expiry": {
          "label": "Anzeigen",
          "keep": "Bisheriges Ende beibehalten",
          "never": "Bis sie entfernt wird",
          "day": "Einen Tag",
          "days3": "Drei Tage",
          "week": "Eine Woche",
          "weeks2": "Zwei Wochen"
        },
        "messages": {
          "saved": "Ankündigung gespeichert.",
          "saveFailed": "Die Ankündigung konnte nicht gespeichert werden.",
          "removed": "Ankündigung entfernt.",
          "removeFailed": "Die Ankündigung konnte nicht entfernt werden."
        },
        "more": {
          "one": "%{count} weitere Ankündigung anzeigen",
          "other": "%{count} weitere Ankündigungen anzeigen"
        }
      }
    }
  }
}
